module.exports = __webpack_public_path__ + "static/img/3.5caf236.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/3.png
// module id = UlNP
// module chunks = 0